module.exports = __webpack_public_path__ + "img/aviation_mix2.62eec8eb.jpg";